module.exports =  {
  hotel: {
    BOOKING_NOW: '즉시 예약',
    Book_Hotel: '호텔 예약',
    Select_your_destination: 'Select your destination',
    Please_enter_your_destination: 'Please enter your destination/hotel',
    Booked_up: 'Booked up',
    Hotel_description: 'Hotel description',
    Check_in_date: 'Check-in date',
    Check_out_date: 'Check-out date',
    Sold_out: 'Sold out',
    Non_refundable: 'Non-refundable',
    reserve: 'Book',
    Pay_Online: 'Pay Online',
    Only_rooms_left_before: 'Only',
    Only_rooms_left_after: 'room(s) left',
    Cancellation_Policy: 'Cancellation Policy',
    See_all_prices_before: 'See all ',
    See_all_prices_after: 'prices',
    Estimated_time_of_arrival: 'Estimated time of arrival',
    make_your_schedule_well_planned: 'Time is for local time zone, please make your schedule well-planned and arrive on time.',
    Hotel_Not_Found: 'Hotel Not Found',
    Please_change_your_search: 'Please change your search',
    Submit_an_application: 'Submit an application',
    Hotel_Confirmation: 'Hotel Confirmation',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Night Stay',
    Hotel_Booking_Number: 'Hotel Booking Number',
    Online_Payment: 'Online Payment',
    The_guest_Room_before: 'The guest',
    The_guest_Room_after: ']',
    Contact_number: 'contact number',
    Bring_all_valid_IDs: 'Please bring all valid IDs of all guests when checking in.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hotels Found',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hotels Presented (',
    Hotels_Presented_after: ' in total)',
    Please_change_the_dates: 'Room not available on your dates, please change the dates.',
    Login: 'Log in on the APP to book hotel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Night(s)',
    Location: 'Location',
    Pictures: 'Pictures',
    Description: 'Description',
    Policy: 'Policy',
    Check_in_and_check_out_time: 'Check- in and check-out time',
    Check_in_and_Check_out_before: 'Check-in: after ',
    Check_in_and_Check_out_center: 'Check-out: before ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Check-in',
    Check_out_time: 'Check-out',
    Facility_Service: 'Facility & Service',
    Payment_methods: 'Payment methods accepted by the hotel',
    Hotel_Address: 'Hotel Address',
    Pay_online: 'Pay online',
    Pay_offline: 'Pay offline',
    Night_stay_before: '',
    Night_stay_after: '-Night Stay,',
    Rooms_total_before: 'Rooms',
    Rooms_total_after: 'in total',
    Guest_name_must_be_provided: 'The full guest name must be provided.',
    Please_fill_in_your_contact_number: 'Please fill in your contact number',
    Select_estimated_time_of_arrival: 'Select estimated time of arrival',
    Number_of_Rooms: 'Number of Rooms',
    Maximum_guests_per_room_before: 'Maximum ',
    Maximum_guests_per_room_after: ' guests per room',
    Many_Rooms: ' Rooms',
    Service_Fee_Included: '(Tax & Service Fee Included)',
    Last_Name: 'Last Name',
    First_Name: 'First Name ',
    Room: 'Room',
    Additional_Tax: 'Additional Tax ',
    Please_inform_the_hotel: 'If you were to arrive beyond estimated arrival time, please inform the hotel in advance.',
    Please_inform_the_hotel_first: 'Arrival at the hotel beyond the estimated arrival time without contacting the hotel in advance will affect the availablity of the room and dinner. Please inform the hotel first to confirm the availablity in such circumstance.',
    Booking_Cancellation: 'Booking Cancellation',
    Reason_of_Cancellation: 'Reason of Cancellation',
    Incorrect_Information_Filled: 'Incorrect Information Filled',
    Itinerary_Changed: 'Itinerary Changed',
    Lower_price_on_other_APP: 'Lower price on other APP',
    Low_quality_hotel: 'Low-quality hotel',
    Book_at_a_lower_price: 'Book at a lower price at the front desk',
    Other: 'Other',
    Please_write_your_reason: 'Please write your reason',
    After_cancellation_done: 'After cancellation done, the payment will be returned to the original payer within 3 working days.',
    How_to_fill_in_the_guest_name: 'How to fill in the guest name',
    It_should_be_exactly_the_same: 'Please provide the guest name in English letters for hotel reservation. It should be exactly the same as the certificate presented when you check in.',
    How_to_fill_in_a_Chinese_name: 'How to fill in a Chinese name:',
    How_to_fill_in_a_English_name: 'How to fill in an English name',
    For_example: 'For example: If your Chinese name is “韩梅梅”, the last name is "Han", the first name is "Meimei".',
    No_specical_characters: 'Do not fill in any numbers or specical characters. ',
    Name_rule_first: 'The last name comes first, the first name follows, and if there is a middle name, it is followed by a space behind the two names. ',
    Name_rule_second: 'For example: Green / Jim Stephanie',
    Details: 'Details',
    Pay_now: 'Pay now',
    Hotel: 'Hotel',
    Check_in: 'Check  in',
    Car: 'Car',
    All_bookings: 'All bookings',
    All: 'All',
    the_real_scene: 'Pictures are for reference only and subject to the real scene.',
    SELECT_COUNTRY_CODE: '국가 또는 지역 선택',
    HOT_COUNTRY_OR_AREA: '부위',
    EVAL_LIST_NO_DATA: '일치하는 데이터가 없습니다.',
    COUPON_TXT: '할인권',
    SHEET: '장',
    NONE_USE_TEXT: '쿠폰 없음',
    USE_COUPON: '할인권 사용',
    BINDING_COUPON: '바인딩',
    DESELECT_COUPON: '선택한 할인권 취소',
    AVAILABLE: '사용 가능',
    NO_COUPON_AVALIABLE: '할인 쿠폰 없습니다',
    UNAVAILABLE: '무효 쿠폰',
    NOT_ACTIVE: '미발효',
    COUPON_TO_BINDING: '할인권 바인딩',
    WRITE_PREFERETIAL_CODE: '할인번호를 입력하세요.',
    BINDING_USE: '바인딩 및 사용',
    HAS_DEDUCTED_BEFORE: '혜택',
    HAS_DEDUCTED_AFTER: '',
    PERSON_COUNT: '인원수',

    // 酒店搜索改版新增翻译
    PREFIX_ROOMS: '침실',
    SUFFIX_ROOM: '개',
    SUFFIX_ROOMS: '개',
    PREFIX_ADULTS: '성인',
    SUFFIX_ADULT: '명',
    SUFFIX_ADULTS: '명',
    PREFIX_CHILDREN: '어린이',
    SUFFIX_CHILD: '명',
    SUFFIX_CHILDREN: '명',
    ROOM: '침실',
    AGE: '세',
    AGES: '세',
    SELECT_ROOMS_TIPS: '어울리는 침실과 침대를 찾기 위해 모든 입주 어린이의 나이를 제시하십시오.',
    CHECK_IN_DETAIL: '디태일',
    CHILD_AGE: '어린이 나이',
    FILTER_CONDITION: '필터 기준',
    NO_MATCH_TIPS: '침실 수”, “인원수” 필터 기준에 맞추지 않은 침실은 다음과 같다.',
    ROOM_COUNT: '침실수',
    GUESTS: '인원수',
    NO_MATCH_HOTEL: '필터 기준에 맞추지 않은 호텔은 다음과 같다.',
    TAXES_INCL: '세금포함총액',
    BOOK_TIMEOUT_TIPS: '페이지가 시간 초과되면 다시 호텔 상세 페이지로 돌아가서 갱신하십시오. 가격과 빈 객실 상황은 이 기간 동안 변동될 수 있습니다.',
    LIST: '리스트',
    RENT_CAR_BOOK: '예약',
    HOTEL_STR: '상세',
    SETTLEMENT_DETAIL: '투숙객 상세페이지',
    CONTACT_NAME: '연락인 이름',
    COUNTRY_CODE: '국가/지역 코드',
    PHONE_NUMBER: '휴대전화번호',
    TRAVEL_PHONE_NUMBER: '성함을 입력해주세요.',
    PLEASE_SELECT_AREA_CODE: '국가/지역 코드 선택',
    NAME_TXT: '이름',
    HOLDER_NAME: '카드 소지자 이름',
    EXPIRATION_DATE: '만기일',
    FORMAT_TXT: '향식',
    SECURITY_CODE: '안전코드',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: '카드 뒤에 3자리 숫자',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '카드 앞면의 4자리',
    ENTER_COMPLETE_CARD_NUM: '카드번호 입력해 주십시오',
    PLEASE_ENTER_HOLDER_NAME: '카드 소지자 이름 입력해 주십시오.',
    ENTER_SECURITY_CODE: '안전코드 입력해 주십시오.',
    ENTER_EXPIRATION_DATE: '만기일 입력해 주십시오',
    ROOM_DETAILS: '객실  상세한 정보',
    CONDITION_CANCEL: '취소조건',
    CHOOSE_PAYMENT_METHOD: '지불수단선택',
    ORDER_TOTAL_LUMP: '예약 신청 총금액',
    CREDIT_CARD_NUM: '지불카드/신용카드번호',
    MAINLAND_CARD_ONLY: '중국대륙 이외 지역에서 발행되는 은행 카드만 가능합니다.',
    SHUT_DOWN: '샷 다운',

    Search: 'Search',
    COST_DESCRIPTION: 'Price Detail',
    TOTAL: 'Total',
    SEE_ORDER_INFO_TO: 'Pay',
    KONW: 'Got it',
    BOOKING_INFORMATION: 'Important Information',
    Book_Now: 'Pay It Now',
    MAP: 'Map',
    CONTACT_INFORMATION: 'Contact Information',
    LOADING: 'Loading...',
    SORT_FILTER: 'Sort/Filter',
    SCREENING: 'Filter',
    SEQUENCE: 'Sort',
    PHONE_ASK: 'Call us',
    ABOVE: '',
    SUBMINT_ORDER: 'Submit',
    OK: 'OK',
    Order_detail: 'Order details',
    BOOKING_INFO: 'Booking Info',
    PAYMENT_AMOUNT: 'Payment Amount',
    Order_time: 'Booking Time',
    ORDER_NUMBERS: 'Booking No',
    PAY_TYPE: 'Payment Method',
    BALANCE: 'Balance',
    CURRENT_BALANCE_BEGIN: 'Balance',
    OVERPLUS_BALANCE_BEGIN: 'Remaining',
    OTHER_PAYMENT: 'Other payment methods',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Click on “Pay It Now” Means You Agree Upon Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Service Agreement》',
    PAYMENT_ORDER: 'Booking Payment',
    Total_pay: 'Amount Due',
    PAY_SUCCESS: 'Payment Accepted',
    CHECK_THE_ORDER: 'Check the Order',
    BACK_TO_INDEX: 'Back to Index',
    CANCEL: 'Cancel',
    RECOMMED: 'Recommend',
    PRICE: 'Price',
    HIGH: 'High',
    LOW: 'Low',
    RESET: 'Reset',
    SELECT_TIME: 'Select Date',
    Hotel_guest: 'The guest',
    Select: 'Please Select',
    Emial_address: 'Please enter email address',
    Booking_explan: 'Booking Information',
    VIEW_MORE: 'View more',
    COLLAPSE: 'Hide',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: '체크인',
    TOURISM_LEAVE_HOTEL: '체크아웃',
    SUBMIT: '확인',
    EMAIL: '이메일',
    BOOK_FAIL: '예약 실패',
    BOOK_FAIL_DETAIL: '앗...예약 실패했습니다.다시 예약해 주십시오. ',
    RESET_BOOK: '다시 주문',
    ROOM_TYPE_LOADING_TIPS: '룸 값을 검색 중,잠시만 기다려 주십시오...',
    NEARBY_HOTEL: '인근 호텔',
    HOT_CITY: '인기도시',

    SEARCH_HISTORY: '검색이력',
    BREAKFAST_INCLUDE: 'breakfast include',
    BREAKFAST_EXCLUDE: 'breakfast exclude',
    DOUBLE_BED: 'double bed',
    TWIN_BED: 'twin bed',
    FREE_CANCEL: 'free cancellation',
    MEALS: 'meals',
    EVALUATION: 'Review',
    FEATURED_REVIEWS: '추천 댓글',
    ALL_REVIEWS: '전부 댓글',
    OVERALL_EVALUATION: '전체 평가',
    ANONYMOUS: '익명',
    EVAL_GENERAL_LIST_1: '매우 좋지 않음',
    EVAL_GENERAL_LIST_2: '좋지 않음',
    EVAL_GENERAL_LIST_3: '일반',
    EVAL_GENERAL_LIST_4: '좋음',
    EVAL_GENERAL_LIST_5: '매우 좋음',
    MAX_IMAGES_WITH_NINE: 'A maximum of 10 pictures can be selected.',
    GRADE_EVAL: '전체 평가를 선택해주세요.',
    DISTANCE_FILTER: 'distance close-far',
    EDIT_EVALUATION: 'give comments',
    GO_TO_EVAL: 'give comments',
    EVAL_POINTS_AWARD: 'Good comments can win 1000points,1000 points=10RMB',
    NEARBY_LIKE_HOTEL: 'similar hotel nearby',
    DISTANCE_HOTEL: 'to hotel',
    PLEASE_ENTER_COMMENT: 'comments',
    AWARD_POINTS_TIPS: 'Best comments can get 1000 points 1000=10RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Anonymous comments will not show your logo and name',
    LOCATION: 'location',
    FACILITY: 'facility',
    SERVICE: 'service',
    HEALTH: 'clean',
    LANGUAGE_SELECT: 'language',
    LIMIT_COMMENT_TXT: '평론의 글자수는 5~2000 자 내입니다.',
    COLLECTED_SUCCEED: 'Collection successful！',
    CANCEL_COLLECT: 'Collection canceled！',
  },
  WX_SHARED: {
    DETAIL_TITLE: '|Hotel Reservation',
    COMMON_TITLE: 'Search Hotel|Tens of thousands of hotels in Asia online for reservation',
    SUB_TITLE: 'BaiGolf provides you with online reservation of Tens of thousands of hotels in Asia, all are at an affordable price and easy to book.',
  },
};



// WEBPACK FOOTER //
// ./src/lang/ko_kr.js